module.exports = __webpack_public_path__ + "img/build_comment_answer@2x.bc422f55.jpg";